import React, { forwardRef, ReactNode } from 'react';
import { MenuButton, MenuButtonProps, useStyleConfig } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';

interface Props extends Omit<MenuButtonProps, `css`> {
  children: ReactNode;
  noIcon?: boolean;
}

export const DropdownButton = forwardRef<HTMLButtonElement, Props>(
  ({ children, noIcon, ...props }, ref): JSX.Element => {
    const styles = useStyleConfig(`MenuButton`);
    return (
      <MenuButton
        ref={ref}
        sx={styles}
        display="flex"
        alignItems="center"
        borderRadius="10px"
        {...props}
      >
        {children} {!noIcon && <ChevronDownIcon />}
      </MenuButton>
    );
  }
);
export type { Props as DropdownButtonProps };
